import gql from "graphql-tag";

export default gql`
    mutation AdminUpdateAccount($input: AdminUpdateAccountInput!) {
        adminUpdateAccount(input: $input) {
            account {
                nodeId
                id
                firstName
                lastName
                contacts {
                    nodes {
                        nodeId
                        id
                        type
                        value
                    }
                }
                
                provider {
                    nodeId
                    name
                    email
                }
            }
        }
    }
`;